module.exports = __webpack_public_path__ + "img/VisitorDefaultPic.2c28765f.png";